// Module
var code = "<a class=\"{{ ::$ctrl.customClass }}\" ng-href=\"{{ ::$ctrl.linkHref }}\" ng-transclude data-local-qa-id=\"entity-link\"></a> ";
// Exports
export default code;